import { useMutation } from "@tanstack/react-query";
import { subscribeNewsletter } from "@/api/email";
import { toast } from "sonner";

/**
 * Hook for newsletter subscription
 * @returns {Object} TanStack Query mutation object
 */
export const useNewsletterSubscribe = () => {
  return useMutation({
    mutationFn: ({ email, source, turnstileToken }) =>
      subscribeNewsletter(email, source, turnstileToken),
    onSuccess: (data) => {
      const successMessage = data?.message || "You'll receive our latest updates and news.";

      toast.success("Successfully subscribed!", {
        description: successMessage,
        duration: 5000,
      });
    },
    onError: (error) => {
      const errorCode = error.response?.data?.errorCode;
      const errorMessage = error.response?.data?.message || error.message || "Failed to subscribe";
      console.error("Newsletter subscription error:", errorMessage);

      if (errorCode === "NEWSLETTER_EMAIL_EXISTS") {
        toast.error("Email already subscribed", {
          description:
            errorMessage ||
            "This email already has a pending or active subscription and cannot be used again.",
          duration: 5000,
        });
        return;
      }

      toast.error("Subscription failed", {
        description: errorMessage,
        duration: 5000,
      });
    },
  });
};
